export default __webpack_public_path__ + "static/media/fha-header.0f2cb8bc.jpg";